/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-reduce-type-parameter */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import moment from 'moment';

import {months} from '../../../constants/Common';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';

// type InputItem = {
//   month: {value: string};
//   unit: {value: string};
//   cost: {value: string};
// };

interface TimeFrameDataItem {
  value: number | null;
  fromDate: string;
  toDate: string;
}

interface TimeFrameData {
  type: string;
  unit: string;
  timeFrame: string;
  data: TimeFrameDataItem[];
}

interface ConvertedData {
  [key: string]: any;
  timeFrameData: TimeFrameData[];
}

const getMonthNumber = (monthAbbr: string) => {
  const date = moment(monthAbbr, 'MMM');

  return date.isValid() ? date.month() + 1 : 0;
};

const mappedObject = (array: any[]) => {
  return array.reduce((acc, item) => {
    const number = getMonthNumber(item) ?? 0;

    acc[item] = number > 9 ? `${number}` : `0${number}`;

    return acc;
  }, {});
};

export const convertData = (
  input: any,
  consumption: {type: string; unit: string},
  cost: {type: string; unit: string}
): ConvertedData | undefined => {
  const {financialYear} = useCompanyStore.getState().preUnits;

  const financialYearMonths: string[] = months[financialYear];

  const monthMap: any = mappedObject(financialYearMonths);

  function getFromToDate(month: string, year: number) {
    const actualYear = Number(monthMap[month]) <= 12 ? year : year + 1;

    const fromDate = moment(`1/${month}/${actualYear}`)
      .startOf('month')
      .format();

    const toDate = moment(`1/${month}/${actualYear}`).endOf('month').format();

    return {
      fromDate: fromDate,
      toDate: toDate
    };
  }

  function parseValue(value: string): number {
    return Number(parseFloat(value?.replace(/,/g, '')).toFixed(2));
  }

  const inputDataMap: {[key: string]: {unitValue: number; costValue: number}} =
    {};
  input?.items?.forEach((item: any) => {
    const valMonthYear = item?.month.split('-');
    let monthYearKey = item?.month;
    if (valMonthYear.length > 1) {
      const _month = valMonthYear[0].toUpperCase();
      const _year =
        valMonthYear[1].length === 4
          ? valMonthYear[1].slice(-2)
          : valMonthYear[1];
      monthYearKey = `${_month}-${_year}`;
    }

    inputDataMap[monthYearKey] = {
      unitValue: parseValue(item?.unit),
      costValue: parseValue(item?.cost)
    };
  });

  const doubleYear = input?.year?.includes('-');

  const yearStart: number = parseInt(input?.year?.split('-')[0], 10);
  const yearEnd: number = parseInt(input?.year?.split('-')[1], 10);

  const decIndex = financialYearMonths.indexOf('Dec');

  const processedUnitData: TimeFrameDataItem[] = financialYearMonths.map(
    (month, index) => {
      const currentYearSuffix = doubleYear
        ? index <= decIndex
          ? yearStart.toString().slice(-2)
          : yearEnd.toString().slice(-2)
        : input?.year.toString().slice(-2);

      const monthLabel = `${month.toUpperCase()}-${currentYearSuffix}`;

      if (inputDataMap[monthLabel]) {
        const {fromDate, toDate} = getFromToDate(month, yearStart);

        return {
          value: inputDataMap[monthLabel].unitValue,
          fromDate: fromDate,
          toDate: toDate
        };
      } else {
        const {fromDate, toDate} = getFromToDate(month, yearStart);

        return {
          value: null,
          fromDate: fromDate,
          toDate: toDate
        };
      }
    }
  );

  const processedCostData: TimeFrameDataItem[] = financialYearMonths.map(
    (month, index) => {
      const currentYearSuffix =
        index <= decIndex
          ? yearStart.toString().slice(-2)
          : yearEnd.toString().slice(-2);

      const monthLabel = `${month.toUpperCase()}-${currentYearSuffix}`;

      if (inputDataMap[monthLabel]) {
        const {fromDate, toDate} = getFromToDate(month, yearStart);

        return {
          value: inputDataMap[monthLabel].costValue,
          fromDate: fromDate,
          toDate: toDate
        };
      } else {
        const {fromDate, toDate} = getFromToDate(month, yearStart);

        return {
          value: null,
          fromDate: fromDate,
          toDate: toDate
        };
      }
    }
  );

  const {items, ...otherKeys} = input;

  const simplifiedOtherKeys: {[key: string]: string | number} = Object.keys(
    otherKeys
  ).reduce(
    (acc, key) => {
      const value = otherKeys[key];
      acc[key] =
        value && typeof value === 'object' && 'value' in value
          ? value.value
          : value;

      return acc;
    },
    {} as {[key: string]: string | number}
  );

  const returnData = {
    ...simplifiedOtherKeys,
    timeFrameData: [
      {
        type: consumption.type,
        unit: consumption.unit,
        timeFrame: 'monthly',
        data: processedUnitData
      },
      {
        type: cost.type,
        unit: cost.unit,
        timeFrame: 'monthly',
        data: processedCostData
      }
    ]
  };

  return returnData;
};
